
<template>
  <div>
    <el-dialog
      custom-class="MyDialog"
      :title="$t('app.emergencyContactSettingsTitle')"
      :visible.sync="dialogEmergency"
      :close-on-click-modal="false"
      @close="cancelEmergency"
      width="575px"
    >
      <p>{{ $t('app.auto_265_edec6409') }}</p>
      <p>{{ $t('app.auto_266_ec12174c') }}</p>
      <div class="select_staff">
        <span class="text_block">{{ $t('app.auto_267_825914e3') }}</span>
        <el-select 
          v-model="valueStaff" 
          multiple 
          filterable
          :multiple-limit="2"
          :placeholder="$t('app.pleaseSelect')" 
          @change="selectStaff"
          style="width: 100%"
          >
          <el-option
            v-for="item in optionsStaff"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
      </div>

      <el-table 
        :data="tableDataEmergency"
        border
        :header-cell-style="{
          background: 'rgb(230, 240, 252)',
          textAlign: 'center',
          color: 'black',
          borderRight: '2px solid #fff',
        }"
        :cell-style="{
          textAlign: 'center',
          padding: '0',
        }"
        style="width: 100%"
      >
          <template slot="empty">
              <el-empty  :description="$t('app.auto_264_fc834024')" :image-size="30"></el-empty>
          </template>
          <el-table-column :label="$t('app.emergencyContactTableSerial')">
            <template slot-scope="scope">
              {{ emergencyContactIndexLabel(scope.$index) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('app.emergencyContactTableName')">
            <template slot-scope="scope">
              {{ emergencyContactCellDisplay(scope.row.name) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('app.emergencyContactTablePhone')">
            <template slot-scope="scope">
              {{ emergencyContactCellDisplay(scope.row.phone) }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="!isEnLocale"
            :label="$t('app.emergencyContactTableDingTalk')"
          >
            <template slot-scope="scope">
              {{ emergencyContactCellDisplay(scope.row.ddNum) }}
            </template>
          </el-table-column>
      </el-table>

      <div class="emergency-switch-row">
        <p class="text_gap">{{ $t('app.auto_268_670ff28c') }}</p>
        <el-switch
          v-model="switchEmergencyValue"
          active-color="#3d76e0"
          inactive-color="#e4e7e9">
        </el-switch>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-divider></el-divider>
        <el-button @click="submitEmergency" type="primary">{{ $t('app.submit') }}</el-button>
        <el-button @click="cancelEmergency">{{ $t('app.auto_576_be030eaf') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LoginUserHelper from "@/util/LoginUserHelper";
import { queryAccountCenterList } from "@/api/AddEmpolyee";
import { queryEmergencyContactList, updEmergencyContact } from '@/api/AccountInterface';

export default {
  data() {
    return {
      tableDataEmergency: [
        { name: '', phone: '', ddNum: '', userId: '', accountId: '' },
        { name: '', phone: '', ddNum: '', userId: '', accountId: '' },
      ],
      valueStaff: [],
      switchEmergencyValue: false,
      optionsStaff: [],
      dialogEmergency: false,
      campusId: LoginUserHelper.getUserInfo().campusId,
      allStaffList: []
    };
  },
  computed: {
    isEnLocale() {
      return this.$i18n.locale === 'en-US';
    },
  },
  methods: {
    emergencyContactIndexLabel(zeroBasedIndex) {
      return this.$t('app.emergencyContactWithIndex', {
        n: zeroBasedIndex + 1,
      });
    },
    /**
     * 接口常把空联系人文案固定成「未设置」；美版下不能当真实值展示，应走当前语言的占位翻译
     */
    normalizeEmergencyContactApiField(val) {
      if (val == null) return '';
      const s = String(val).trim();
      if (s === '' || s === '未设置' || s === 'Not set') return '';
      return s;
    },
    emergencyContactCellDisplay(val) {
      const s = this.normalizeEmergencyContactApiField(val);
      if (s === '') return this.$t('app.auto_265_2be97a89');
      return s;
    },
    async init(){
      await this.queryEmergencyContactList();
      await this.queryAccountCenterList();
    },
    async queryAccountCenterList() {
      let params = {
        campusId: this.campusId
      };
      let { data, code, message } = await queryAccountCenterList(params)
      if (code === 0) {
        this.allStaffList = data;
        this.optionsStaff = data.map(item => {
          return {
            value: item.account_id,
            label: item.real_name
          };
        });
        // 默认选中状态
        // 列表中会返回两条"未设置"数据需要过滤掉
        this.valueStaff = this.tableDataEmergency.filter(item => item.accountId > 0).map(item => item.accountId);
      } else {
        this.$message.error(this.$getCodeMessage(code, message))
      }
    },
    async queryEmergencyContactList() {
      try {
        const { data, code, message } = await queryEmergencyContactList({ campusId: this.campusId });
        
        if (code === 0) {
          this.tableDataEmergency = this.formatEmergencyContacts(data?.contactList || []);
          this.switchEmergencyValue = data?.isShow === 1;
        } else {
          throw new Error(message);
        }
      } catch (error) {
        this.$message.error(this.$t('app.auto_273_aeb07a52'));
        this.tableDataEmergency = this.getDefaultEmergencyContacts();
        this.switchEmergencyValue = false;
      }
    },

    formatEmergencyContacts(contactList) {
      if (contactList.length === 0) {
        return this.getDefaultEmergencyContacts();
      }
      return contactList.map((item) => ({
        name: this.normalizeEmergencyContactApiField(item.accountTrueName),
        phone: this.normalizeEmergencyContactApiField(item.accountPhone),
        ddNum: this.normalizeEmergencyContactApiField(item.dingPhone),
        userId: item.userId || '',
        accountId: item.accountId || '',
      }));
    },

    getDefaultEmergencyContacts() {
      return [
        { name: '', phone: '', ddNum: '', userId: '', accountId: '' },
        { name: '', phone: '', ddNum: '', userId: '', accountId: '' },
      ];
    },
    async submitEmergency() {
      let params = {
        campusId: this.campusId,
        isShow: this.switchEmergencyValue ? 1 : 0,
        contactList: this.tableDataEmergency.map((item,index) => {
          return {
            type: index + 1,
            accountId: item.accountId,
            userId: item.userId
          };
        })
      };
      let { data, code, message } = await updEmergencyContact(params)
      if ( code === 0 && data === 1) {
          this.dialogEmergency = false;
          this.$message.success(this.$t('app.auto_285_c5128c5f'));
        } else {
          this.$message.error(this.$t('app.auto_102_d12681fa'));
      }
      this.init();
    },
    cancelEmergency() {
      this.dialogEmergency = false;
      this.init();
    },
    selectStaff(value) {     
      // 创建一个Map来快速查找staff成员
      const staffMap = new Map(this.allStaffList.map(staff => [staff.account_id, staff]));
      
      const defaultContact = { name: '', phone: '', ddNum: '', userId: '', accountId: '' };

      this.tableDataEmergency = value.slice(0, 2).map((accountId) => {
        const staffMember = staffMap.get(accountId);
        if (staffMember) {
          return {
            name: this.normalizeEmergencyContactApiField(staffMember.real_name),
            phone: this.normalizeEmergencyContactApiField(staffMember.phone),
            ddNum: this.normalizeEmergencyContactApiField(staffMember.dingPhone),
            userId: staffMember.userId,
            accountId: staffMember.account_id,
          };
        }
        return { ...defaultContact };
      });

      while (this.tableDataEmergency.length < 2) {
        this.tableDataEmergency.push({ ...defaultContact });
      }
    },
    removeStaff() {
      this.tableDataEmergency = this.tableDataEmergency.filter(item => {
        return this.valueStaff.includes(item.accountId);
      });
    }
  },
  components: {

  },
  mounted() {
    this.init();
  },
}
</script>

<style lang="scss" scoped>

.MyDialog {
  border-radius: 20px;

  .el-dialog__header {
    background: rgb(74, 131, 232);
    border-radius: 20px 20px 0 0;

    .el-dialog__title,
    .el-dialog__close {
      color: white;
    }
  }

  .dialog-footer {
    button {
      border-radius: 20px;
    }
  }
}

.select_staff {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  .text_block {
    margin-right: 20px;
    display: inline-block;
    width: 100px;
  }
}

.emergency-switch-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 12px;
}

.text_gap {
  flex: 1;
  min-width: 0;
  margin: 0;
  line-height: 1.5;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

.emergency-switch-row .el-switch {
  flex-shrink: 0;
  margin-top: 4px;
}

::v-deep .MyDialog .el-empty__description {
  margin-top: -10px;
  line-height: 10px;
}

::v-deep .MyDialog .el-dialog__body {
  min-height: 320px;
  max-height: 70vh;
  overflow-y: auto;
  padding: 30px 20px 10px;
}

// 美版环境下提示语文本换行样式
::v-deep .MyDialog .el-dialog__body p {
  word-break: break-word;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.6;
  margin-bottom: 8px;
}
</style>
